var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import CBRContext from '../context';
import { CardFooter } from '../execution/subcomponents';
import StepButton from '../../step-button';
import ErrorIllustration from './error-illustration';
import { backToAccountManagerWithError } from '../../../const/analytics';
import { ErrorContainer, ErrorDescription, ErrorHeading, ErrorIllustrationWrapper } from './subcomponents';
var RefundError = function () {
    var t = useTranslation().t;
    var backToAccountManagerHandler = useContext(CBRContext).backToAccountManagerHandler;
    return (_jsxs(_Fragment, { children: [_jsxs(ErrorContainer, { children: [_jsx(ErrorIllustrationWrapper, { children: _jsx(ErrorIllustration, {}) }), _jsx(ErrorHeading, { children: t('error.header') }), _jsx(ErrorDescription, { children: t('error.subText') })] }), _jsx(CardFooter, { children: _jsx(StepButton, __assign({ onClick: backToAccountManagerHandler, primary: true }, backToAccountManagerWithError, { textContent: t('button.backToAccountManager') })) })] }));
};
export default RefundError;
